import React from 'react';
import { Box, Flex, Spinner as CSpinner } from '@chakra-ui/react';
const Spinner = () => (
  <Flex
    flexDirection="column"
    width="100wh"
    height="100vh"
    backgroundColor="transparent"
    justifyContent="center"
    alignItems="center"
    zIndex="1000"
  >
    <Box>
      <CSpinner speed="0.8s" emptyColor="blue.100" color="blue.900" size="xl" />
    </Box>
  </Flex>
);

export default Spinner;
